import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=d559c4ec&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports